import { useChartSeries } from '@/features/charts';
import BasicChartBlock from '@/features/markets/components/Chart/BasicChartBlock';
import useInViewport from '@/shared/hooks/useInViewport';
import type { TemplateChartSeries } from '@/shared/types/charts';

type SpotChartBlockType = {
  layout?: { fullWidth?: boolean; height?: number };
  templateChartSeries?: TemplateChartSeries[];
};
export const SpotChartBlock = ({ layout, templateChartSeries }: SpotChartBlockType) => {
  const [containerRef, isInViewport] = useInViewport();
  const { loading, error, chartSeries } = useChartSeries(
    templateChartSeries,
    false,
    false,
    isInViewport
  );

  return (
    <BasicChartBlock
      chartSeries={chartSeries}
      chartType='spot'
      containerRef={containerRef}
      error={error}
      layout={layout}
      loading={loading}
    />
  );
};
